<template lang="pug">
  section
    b-container
      h4.mt-0 Artist profile
      .breadcrumbs.text-muted.small.py-3
        router-link(:to="{name: 'Artists'}")
          font-awesome-icon.mr-2(icon="chevron-left")
          span ALL
      content-loader(:height="7", v-if="alert.loading")
      .row(v-else="")
        .col-12
          b-card
            .container
              .row
                .col-md-3.pl-0.text-center.pt-3
                  b-avatar.mb-2(:src="artist.avatar_file_id", :text="`${artist.firstname[0]}${artist.lastname[0]}`", size="6rem")
                  .text-center
                    span {{ artist.base }}
                  hr
                  .text-center(v-if="artist.facebook_url || artist.instagram_url || artist.behance_url")
                    a.mr-2(v-if="artist.facebook_url", :href="artist.facebook_url", target="_blank")
                      font-awesome-icon.mr-1(:icon="['fab', 'facebook']")
                    a.mr-2(v-if="artist.instagram_url", :href="artist.instagram_url", target="_blank")
                      font-awesome-icon.mr-1(:icon="['fab', 'instagram']")
                    a.mr-2(v-if="artist.behance_url", :href="artist.behance_url", target="_blank")
                      font-awesome-icon.mr-1(:icon="['fab', 'behance']")
                  .text-center(v-else="")
                    p No social media
                  hr
                  .text-center(v-if="artist.portfolio_file_url || artist.portfolio_url")
                    a(v-if="artist.portfolio_file_url", :href="artist.portfolio_file_url", target="_blank")
                      font-awesome-icon.mr-2(icon="file")
                    a(v-if="artist.portfolio_url", :href="artist.portfolio_url", target="_blank")
                      font-awesome-icon.mr-2(icon="external-link-alt")
                    span Portfolio
                  .text-center(v-else="")
                    p No portfolio
                  hr
                .col-md-9
                  h2.mt-1.mb-1 {{ `${artist.firstname} ${artist.lastname}` }}
                  // .small {{ `Based in ${artist.base}` }}
                  h4 Bio
                  p.mt-2 {{ artist.bio }}
                  h4 Further info
                  p {{ artist.other_info }}
                  .small {{ `Average price: ${formatRands(artist.price_avg)}` }}
                  h4 Contact
                  p {{ `${artist.email} | ${artist.phone}` }}
                  .text-right.mt-2(v-if="artist.status == 'pending'")
                    b-button.btn-clear(@click="declineThisArtist") Decline
                    button-load(:flag="alert.busy", label="Approve", classes="btn-outline", v-on:clicked="approveThisArtist")
                  .text-right.mt-2(v-else-if="artist.status == 'active'")
                    button-load(:flag="alert.busy", label="Remove", classes="btn-outline", v-on:clicked="removeThisArtist")
                    //button-load(:flag="alert.busy", label="Suspend", classes="btn-clear", v-on:clicked="suspendThisArtist")
        .col-md-6
          b-card.mt-3
            h4 Address
            b-container
              span(v-if="address")
                p.m-0 {{ address.line_1 }}
                p.m-0 {{ address.line_2 }}
                p.m-0 {{ address.suburb }}
                p.m-0 {{ address.city }}
                p.m-0 {{ address.zip }}
              div(v-else="")
                p This artist has not yet completed their address details
        .col-md-6
          b-card.mt-3
            h4 Payout details
            .row(v-if="bankAccount")
              .col-6
                span.small Bank
                p.mb-1 {{ bankAccount.bank_name }}
              .col-6
                span.small Type
                p.mb-1 {{ bankAccount.type }}
              .col-6
                span.small Account
                p.mb-1 {{ bankAccount.account_number }}
            .row(v-else="")
              .col-12
                p This artist has not yet completed their bank details
                button-load(:flag="alert.busy", label="SEND REMINDER", classes="btn-outline", v-on:clicked="sendAccountReminder")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import { mapState, mapActions, mapGetters } from 'vuex';
import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
import router from '@/router';

export default {
  name: 'Artist',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      artist: null,
      bankAccount: null,
      address: null,
    };
  },
  computed: {
    ...mapState('resource', ['art_forms', 'art_media', 'art_styles', 'art_subjects']),
    ...mapGetters('resource', ['getArtMedia']),
  },
  methods: {
    ...mapActions('art', ['addArt', 'updateArt']),
    async approveThisArtist() {
      try {
        this.busy();
        await apiService.approveArtist(this.artist.id);
        this.artist.status = 'available';
        this.success('Artist approved');
      } catch (error) {
        console.log(error);
        this.error('Could not approve artist at this time');
      }
    },
    async removeThisArtist() {
      try {
        this.busy();
        await apiService.removeArtist(this.artist.id);
        router.push({ name: 'Artists' });
      } catch (error) {
        console.log(error);
        this.error('Could not remove artist at this time');
      }
    },
    async declineThisArtist() {
      try {
        this.busy();
        await apiService.declineArtist(this.artist.id);
        router.push({ name: 'Artists' });
      } catch (error) {
        console.log(error);
        this.error('Could not decline artist at this time');
      }
    },
    async suspendThisArtist() {
      try {
        this.busy();
        await apiService.suspendArtist(this.artist.id);
        this.artist.status = 'pending';
        this.success('Artist suspended');
      } catch (error) {
        console.log(error);
        this.error('Could not suspend artist at this time');
      }
    },
    async sendAccountReminder() {
      console.log('sending reminderder');

      try {
        this.busy();
        await apiService.sendAccountReminder(this.artist.id);
        this.success('Reminder sent');
      } catch (error) {
        console.log(error);
        this.error(error);
        // this.error('Could not send reminder at this time');
      }
    },
  },
  async created() {
    if (this.$route.params.artistId) {
      this.loading();
      this.artist = await apiService.getArtist(this.$route.params.artistId);
      if (this.artist.address_id) {
        this.address = await apiService.getArtistAddress(this.$route.params.artistId);
      }
      this.bankAccount = await apiService.getArtistBankAccount(this.$route.params.artistId);
      this.clear();
    }
  },
};
</script>

<style lang="scss" scoped>

  .img-preview {
    width: 100px !important;
  }
  .img-main {
    width: 100%;
    // max-height: 90vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Artist.vue